import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("myclinic_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  const activeClinic = localStorage.getItem("myclinic_active_clinic");
  if (activeClinic) config.headers["X-Clinic-Id"] = activeClinic;
  const activeBranch = localStorage.getItem("myclinic_active_branch");
  if (activeBranch && activeBranch !== "all") config.headers["X-Branch-Id"] = activeBranch;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      const path = window.location.pathname;
      if (path !== "/login" && !path.startsWith("/link")) {
        localStorage.removeItem("myclinic_token");
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);

export function formatApiError(detail) {
  if (detail == null) return "Terjadi kesalahan, silakan coba lagi.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
